import { render, staticRenderFns } from "./stories.vue?vue&type=template&id=5a21f743&"
import script from "./stories.vue?vue&type=script&lang=js&"
export * from "./stories.vue?vue&type=script&lang=js&"
import style0 from "./stories.vue?vue&type=style&index=0&id=5a21f743&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports